module.exports = __webpack_public_path__ + "static/img/contract (1).565195a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contract (1).jpg
// module id = rseC
// module chunks = 1